import { render, staticRenderFns } from "./arrow-wrap.vue?vue&type=template&id=3c6dec42&"
import script from "./arrow-wrap.vue?vue&type=script&lang=js&"
export * from "./arrow-wrap.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports